import React,{Component} from 'react';
import { ref } from '../config/constants'
import moment from 'moment'


class ReturnSheet extends Component{
    constructor(){
        super();
        
        this.saveToInventory = this.saveToInventory.bind(this);
        this.state ={
            inventoryList: {},
            BendedPrice : {}
        }
    }

    componentDidMount() {
        let category = ref.child("BendedPrice").orderByChild('status').equalTo('Active');
            category.on("value", function(snap){
                this.setState({
                    BendedPrice : snap.val()
                })
            }.bind(this))

        

        var inventory = ref.child("Inventory").child("Sheets")
            inventory.on("value", function(snap){
                this.setState({
                    inventoryList : snap.val()
                })
            }.bind(this))       
    }

   
    saveToInventory(e){
        e.preventDefault()
        if(!this.state.inventoryList){
            let data={
                    thickness : this.thickness.value,
                    dimension : this.dimension.value,
                    length : this.length.value,
                    color : this.color.value,
                    count : parseInt(this.count.value,10)
                }
            let stockIn={
                    status: "In",
                    thickness : this.thickness.value,
                    dimension : this.dimension.value,
                    length : this.length.value,
                    color : this.color.value,
                    count : parseInt(this.count.value,10),
                    date : moment().format("MM DD YYYY")
                    
                }
                ref.child("Inventory").child("Sheets").push(data).then(alert("Products has been returned"))
                ref.child("StockCard").child("Sheets").push(stockIn)
        }else{
            var exist = false
            var sheetKey = ""
            var sheetCount = 0
            Object.keys(this.state.inventoryList).map(key => {
                let list = this.state.inventoryList[key]
                if(list.thickness === this.thickness.value && list.color === this.color.value && list.dimension === this.dimension.value && list.length === this.length.value ){
                    exist = true
                    sheetKey = key
                    sheetCount = list.count                
                }  
            })

            if(exist === true){
                let count = sheetCount + parseInt(this.count.value,10)
                let update = {
                        count : count
                    }
                let stockIn={
                    status: "In",
                    thickness : this.thickness.value,
                    dimension : this.dimension.value,
                    length : this.length.value,
                    color : this.color.value,
                    count : parseInt(this.count.value,10),
                    date : moment().format("MM DD YYYY")                    
                }
                ref.child("Inventory").child("Sheets").child(sheetKey).update(update).then(alert("Products has been returned"))
                ref.child("StockCard").child("Sheets").push(stockIn)
            }else{
                let data={
                    thickness : this.thickness.value,
                    dimension : this.dimension.value,
                    length : this.length.value,
                    color : this.color.value,
                    count : parseInt(this.count.value,10)
                }
                let stockIn={
                    status: "In",
                    thickness : this.thickness.value,
                    dimension : this.dimension.value,
                    length : this.length.value,
                    color : this.color.value,
                    count : parseInt(this.count.value,10),
                    date : moment().format("MM DD YYYY")                    
                }
                ref.child("Inventory").child("Sheets").push(data).then(alert("Products has been returned"))
                ref.child("StockCard").child("Sheets").push(stockIn)
            }
        }
        this.formSubmit.reset()
    }

    
          
    render() {

        return (
            <div className="row">
                <form ref={input => this.formSubmit = input} onSubmit={this.saveToInventory}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="">
                                <select className="form-control" name="thickness" ref={ input => this.thickness=input } onClick={this.handleChange}>
                                    <option>Select Thickness</option>
                                    <option value="4MM">4MM</option>
                                    <option value="5MM">5MM</option>
                                    <option value="6MM">6MM</option>
                                </select>
                            </div>
                            <div className="">
                                <select className="form-control" name="dimension" ref={ input => this.dimension=input } onClick={this.handleChange}>
                                    <option>Select Dimension</option>
                                    { 
                                        this.state.BendedPrice &&
                                        Object.keys(this.state.BendedPrice).map(function (key){
                                            let list = this.state.BendedPrice[key]
                                            return <option value={list.dimension} key={key}> {list.dimension} </option>
                                       }.bind(this))
                                    }
                                </select>
                            </div>
                            <div className="">
                                <select className="form-control" name="length" ref={ input => this.length=input } onClick={this.handleChange}>
                                    <option>Select Length</option>
                                    <option value="2.44 M">2.44 M</option>
                                    <option value="4.55 M">4.55 M</option>
                                </select>                        
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="">
                                <select className="form-control" name="color" ref={ input => this.color=input } >
                                    <option>Select Color</option>
                                    <option value="red">red</option>
                                    <option value="gray">gray</option>
                                    <option value="black">black</option>
                                    <option value="blue">blue</option>
                                </select>
                            </div>
                            <div className="">
                                <div className="row">
                                    <div className="col-md-4 forLabelInput">
                                        <p>Enter Quantity</p>
                                    </div>     
                                    <div className="col-md-8">
                                        <input type="text" className="form-control col-md-3 forQty" name="count" defaultValue = {0}
                                         ref={ input => this.count = input } />
                                    </div>
                                </div>
                            </div>
                            <div className="genButtonHolder">
                                <button type="submit" className="btn btn-sm btn-danger" > Save</button> 
                            </div>
                        </div>
                    </div>    
                </form>  
            </div>
        );
    }
}

export default  ReturnSheet;



// WEBPACK FOOTER //
// ./src/components/ReturnSheet.js